import error from "../images/404-error-page-examples-best.jpg";

export const RouteNotFound = () => {
  return (
    <section>
      <img src={error} alt="404 page not found" />
    </section>
  );
};
